module.exports = __webpack_public_path__ + "media/assets/login/icon-signup-5-6cdfb0f223faff78e1fa9400a0a0a6b8.svg";